import { Injectable } from '@angular/core';
import {
  Firestore,
  collection,
  doc,
  query,
  where,
  getDoc,
  collectionData,
  docData
} from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Process } from '../models/process';

@Injectable({
  providedIn: 'root'
})
export class ProcessService {
  constructor(private firestore: Firestore) {}

  getProcesses(): Observable<Process[]> {
    const processesRef = collection(this.firestore, 'process');
    return collectionData(processesRef, { idField: 'id' }) as Observable<Process[]>;
  }

  getProcessById(id: string): Observable<Process> {
    const processDocRef = doc(this.firestore, `process/${id}`);
    return docData(processDocRef, { idField: 'id' }) as Observable<Process>;
  }
}
